import { useNavigate, useParams } from "react-router-dom";
import { validateId } from "utils/validators";
import { ROUTE_PATHS } from "const/paths";
import { useUserDetailsQuery } from "@ticketingplatform/api/dist/users";
import { UserRole } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { useUserDelete } from "../UserList/hooks";

import { UseUserDetailsReturnType } from "./types";

export const useUserDetails = (): UseUserDetailsReturnType => {
  const { id } = useParams();
  const navigate = useNavigate();
  const validatedId = validateId(id);

  const { onConfirm } = useUserDelete();

  const { data, loading } = useUserDetailsQuery({
    variables: { id: validatedId },
    onError: () => navigate(ROUTE_PATHS.SettingsUsers),
  });

  const { user } = data || {};

  const onDeleteUser = async () => {
    await onConfirm(validatedId);
    navigate(ROUTE_PATHS.SettingsUsers);
  };

  return {
    user: {
      input: {
        firstName: user?.firstName || "",
        lastName: user?.lastName || "",
        phoneNumber: user?.phoneNumber || "",
        role: user?.role || UserRole.ADMIN,
      },
    },
    loading,
    onDeleteUser,
  };
};
